import React, { useState, useEffect } from "react";
import {
  BankOutlined,
  CloseCircleOutlined,
  DollarOutlined,
  TeamOutlined,
  SearchOutlined
} from "@ant-design/icons";
import { Row, Col, Card, Spin, Button, Table, Tooltip, } from "antd";
import { BarChartOutlined } from "@ant-design/icons";
import Chart from "react-apexcharts";
import CountUp from "react-countup";
import { aictia } from "../../../const/api";
import { useTranslation } from "react-i18next";

function Index() {
  const [data, setData] = useState([]);
  const [activityPie, setActivityPie] = useState({ labels: [], series: [] });

  const [companyPie, setCompanyPie] = useState({ labels: [], series: [] });
  const [activtyTypeSeries, setActivityTypeSeries] = useState([]);
  const [activtyCompanySeries, setCompanyTypeSeries] = useState([]);
  const [componyGrafikType, setComponyGrafikType] = useState(true);
  const [capitalGrafikType, setCapitalGrafikType] = useState(true);

  const [activityYears, setActivityYears] = useState([]);
  const [companyActivityYears, setCompanyActivityYears] = useState([]);
  const [spin, setSpin] = useState(false);
  const [typeOfCompanyX, setTypeOfCompanyX] = useState([]);
  const [typeOfCompanySeries, setTypeOfCompanySeries] = useState([]);
  const [typeOfCompanyCapital, setTypeOfCompanyCapital] = useState([]);
  const [bottomTab, setBottomTab] = useState("sayi");

  const { t } = useTranslation();
  const [dashboardData, setdashboardData] = useState([]);

  const columns = [
    {
      title: "#",
      dataIndex: "tableIndex",
      width: 70,
      align: "center",
      onHeaderCell: () => ({
        style: {
          fontSize: 11,
          fontWeight: 800,
          color: "#94A3B8",
          textTransform: "uppercase",
          letterSpacing: 1.5,
          background: "#fff",
        },
      }),
      onCell: () => ({
        style: {
          fontSize: 12,
          fontWeight: 600,
          color: "#94A3B8",
          textAlign: "center",
        },
      }),
    },
    {
      title: "Adlar",
      dataIndex: "name",
      onHeaderCell: () => ({
        style: {
          fontSize: 11,
          fontWeight: 800,
          color: "#94A3B8",
          textTransform: "uppercase",
          letterSpacing: 1.5,
          background: "#fff",
        },
      }),
      onCell: () => ({
        style: {
          fontSize: 13,
          fontWeight: 700,
          color: "#1E293B",
          textTransform: "uppercase",
        },
      }),
    },
    {
      title: "Şirkət sayı",
      dataIndex: "count",
      align: "right",
      onHeaderCell: () => ({
        style: {
          fontSize: 11,
          fontWeight: 800,
          color: "#94A3B8",
          textTransform: "uppercase",
          letterSpacing: 1.5,
          background: "#fff",
        },
      }),
      onCell: () => ({
        style: {
          fontSize: 13,
          fontWeight: 800,
          color: "#0F172A",
        },
      }),
      render: (text, record) => (
        <Tooltip title={record.companyNames}>
          <span>{text}</span>
        </Tooltip>
      ),
    },
  ];

  const getData = () => {
    setSpin(true);
    aictia.get("Dashboard").then((res) => {
      setSpin(false);
      setData(res.data);
      const activityFields = res.data?.dashboard_GroupedData.groupOfActivity

      const companyType = res.data?.dashboard_GroupedData.groupOfTypeOfCompany

      const typeOfCompanyCapital = res.data?.dashboard_GroupOfTypeOfActivity.authorizedCapitalByTypeOfActivity
      const typeOfCompany = res.data?.dashboard_GroupOfTypeOfActivity.countOfCompamyByTypeOfActivity

      if (activityFields) {
        const activityLabels = activityFields?.map((elem) => elem.name);
        const activitySeries = activityFields?.map((elem) => elem.count);
        setActivityPie({ activityLabels, activitySeries });
      }


      if (companyType) {
        const companyLabels = companyType?.map((elem) => {
          const name = elem.name === "İctimai birlik" ? "İ/B" : elem.name; // 'İctimai birlik' ise 'IB' yap
          return `${name}`;
        });

        const companySeries = companyType?.map((elem) => elem.count);
        setCompanyPie({ companyLabels, companySeries });
      }


      const allTypeOfCompany = typeOfCompanyCapital?.map((item) => item.name);
      const allTypeOfCompanySeries = typeOfCompanyCapital?.map((item) => item.sumAuthorizedCapital);
      const allTypeOfCompanyCount = typeOfCompany?.map((item) => item.count);
      setTypeOfCompanyX(allTypeOfCompany);
      setTypeOfCompanyCapital(allTypeOfCompanySeries);
      setTypeOfCompanySeries(allTypeOfCompanyCount);

      setdashboardData(
        res.data.dashboard_SameOffcialCeo?.officialCEOofSameCompany?.map((data, index) => ({
          ...data,
          key: index + 1,
          index,
          tableIndex: index + 1,

        })
        ))
    });
  };
  const activitySumFunc = () => {
    const activityType = data?.statisticByYears?.authorizedCapitalByYears
    const allYears = [
      ...new Set(activityType?.map((item) => item.years)),
    ];
    const yearsAfter2015 = capitalGrafikType ? allYears
      .filter((year) => parseInt(year) >= 2015).reverse() : allYears
        .filter((year) => parseInt(year) >= 2015)
    setActivityYears(yearsAfter2015);

    let cumulativeSum1 = 0;
    const cumulativeData1 = activityType?.map(item => {

      cumulativeSum1 += item.sumAuthorizedCapital; // Birikimli toplama mevcut elemanın count'unu ekle
      return { ...item, cumulativeCount: cumulativeSum1 }; // Yeni bir nesne döndür
    });
    const names = [...new Set(cumulativeData1?.filter(item => parseInt(item.years) >= 2015).map((item) => capitalGrafikType ? item.cumulativeCount : item.sumAuthorizedCapital))];
    const reverseName = capitalGrafikType ? names.reverse() : names;
    setActivityTypeSeries(reverseName);


  }
  const companySumFunc = () => {
    const companySum = data?.statisticByYears?.companyCountByYears

    const allYears = [
      ...new Set(companySum?.map((item) => item.years)),
    ];
    const yearsAfter2015Company = componyGrafikType ? allYears
      .filter((year) => parseInt(year) >= 2015).reverse() : allYears
        .filter((year) => parseInt(year) >= 2015)
    setCompanyActivityYears(yearsAfter2015Company);

    let cumulativeSum = 0; // Birikimli toplamı tutacak değişken
    // Birikimli toplamı tutacak değişken
    const cumulativeData = companySum?.map(item => {
      cumulativeSum += item.count; // Birikimli toplama mevcut elemanın count'unu ekle
      return { ...item, cumulativeCount: cumulativeSum }; // Yeni bir nesne döndür
    });

    const names1 = [...new Set(cumulativeData?.filter(item => parseInt(item.years) >= 2015).map((item) => componyGrafikType ? item.cumulativeCount : item.count))];
    const reverseName1 = componyGrafikType ? names1.reverse() : names1;

    setCompanyTypeSeries(reverseName1);


  }


  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {

    if (data) {
      activitySumFunc();
      companySumFunc();
    }

  }, [data, componyGrafikType, capitalGrafikType]);


  const activityField = {
    options: {
      labels: activityPie.activityLabels || [],
      plotOptions: {
        pie: {
          dataLabels: {
            offset: -30,
            enabled: false, // Yüzdelik değerleri tamamen kaldır
          },
        },
      },
      dataLabels: {
        enabled: false, // Ek olarak global dataLabels'i kapat
      },
      chart: {
        background: 'transparent', // Şeffaf arka plan
        marginTop: 50,
        marginBottom: 50,
        marginLeft: 50,
        marginRight: 50,
      },
      stroke: {
        show: false, // Çevre kenar çizgilerini kaldır
      },
      legend: {
        position: 'right', // Legend'leri grafiğin altına taşır
        fontSize: '12px',
        offsetY: 10,
        formatter: function (val, opts) {
          return val + " - " + opts.w.globals.series[opts.seriesIndex] + " (" + opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(2) + "%) ";
        }

      },
    },
    series: activityPie.activitySeries || [],
  };

  const typeOfCompany = {
    options: {
      labels: companyPie.companyLabels || [],
      plotOptions: {
        pie: {
          dataLabels: {
            offset: -30,
            enabled: false, // Yüzdelik değerleri tamamen kaldır
          },
        },
      },
      dataLabels: {
        enabled: false, // Ek olarak global dataLabels'i kapat
      },
      chart: {
        background: 'transparent', // Şeffaf arka plan
        marginTop: 50,
        marginBottom: 50,
        marginLeft: 50,
        marginRight: 50,
      },
      stroke: {
        show: false, // Çevre kenar çizgilerini kaldır
      },
      legend: {
        position: 'right', // Legend'leri grafiğin altına taşır
        fontSize: '12px',
        offsetY: 10,
        formatter: function (val, opts) {
          return val + " - " + opts.w.globals.series[opts.seriesIndex] + " (" + opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(1) + "%)";
        }
      },
    },
    series: companyPie.companySeries || [],
  };
  const responsive = window.innerWidth < 2000 && window.innerWidth > 1700 ? true : false;
  const responsive2 = window.innerWidth < 1500;
  const state = {
    options: {
      chart: {
        id: "basic-bar",
        background: 'transparent', // Şeffaf arka plan
        toolbar: {
          show: false, // Toolbar'i kaldır
        },
      },
      plotOptions: {
        bar: {
          horizontal: true, // Çubukları yatay yap
        },
      },
      xaxis: {
        categories: activityYears,
        labels: {
          formatter: function (val) {

            // Sayıları kısaltarak göster
            if (capitalGrafikType && val >= 1000000) {
              return (val / 1000000) + "M"; // Milyonlar için
            } else if (capitalGrafikType && val >= 1000) {
              return (val / 1000) + "K"; // Binler için
            }
            return val; // Küçük sayılar
          },
        },

      },
      yaxis: {
        labels: {
          formatter: function (val) {

            // Sayıları kısaltarak göster
            if (!capitalGrafikType && val >= 1000000) {
              return (val / 1000000) + "M"; // Milyonlar için
            } else if (!capitalGrafikType && val >= 1000) {
              return (val / 1000) + "K"; // Binler için
            }
            return val; // Küçük sayılar
          },
        },
      },

      dataLabels: {
        enabled: false, // Barların üzerindeki yazıları gizle
      },
    },
    series: [
      {
        name: "Ümumi nizamnamə kapitalı",
        data: activtyTypeSeries,
      }
    ]
  };
  const state1 = {
    options: {
      chart: {
        id: "basic-bar",
        background: 'transparent', // Şeffaf arka plan
        toolbar: {
          show: false, // Toolbar'i kaldır
        },
        width: '100%'
      },
      plotOptions: {
        bar: {
          horizontal: true, // Çubukları yatay yap
        },
      },
      xaxis: {
        categories: companyActivityYears,

      },


      dataLabels: {
        enabled: false, // Barların üzerindeki yazıları gizle
      },
    },
    series: [
      {
        name: "Şirkət sayı",
        data: activtyCompanySeries,
      }
    ]
  };

  const state2 = {
    options: {
      chart: {
        id: "basic-bar",
        background: 'transparent', // Şeffaf arka plan
        toolbar: {
          show: false, // Toolbar'i kaldır
        },
      },
      xaxis: {
        categories: typeOfCompanyX,
      },
      yaxis: {
        labels: {
          formatter: function (val) {

            // Sayıları kısaltarak göster
            if (val >= 1000000) {
              return (val / 1000000) + "M"; // Milyonlar için
            } else if (val >= 1000) {
              return (val / 1000) + "K"; // Binler için
            }
            return val; // Küçük sayılar
          },
        },
      },

      dataLabels: {
        enabled: false, // Barların üzerindeki yazıları gizle
      },
      grid: {
        padding: {
          bottom: 70,
        },
      },
      responsive: [
        {
          breakpoint: 1550,
          options: {
            xaxis: {
              labels: {
                rotate: -45,
                style: {
                  fontSize: "10px",
                },

              },
            },
          },
        },
      ],
    },

    series: [
      {
        name: "Nizamnamə kapitalı",
        data: typeOfCompanyCapital
      }
    ]
  };
  const state3 = {
    options: {
      chart: {
        id: "basic-bar",
        background: 'transparent', // Şeffaf arka plan
        toolbar: {
          show: false, // Toolbar'i kaldır
        },
      },
      xaxis: {
        categories: typeOfCompanyX,

      },
      yaxis: {
        labels: {
          formatter: function (val) {


            // Sayıları kısaltarak göster
            if (val >= 1000000) {
              return (val / 1000000) + "M"; // Milyonlar için
            } else if (val >= 1000) {
              return (val / 1000) + "K"; // Binler için
            }
            return val; // Küçük sayılar
          },
        },
      },

      dataLabels: {
        enabled: false,
      },
      grid: {
        padding: {
          bottom: 70,
        },
      },
      responsive: [
        {
          breakpoint: 1550,
          options: {
            xaxis: {
              labels: {
                rotate: -45,
                style: {
                  fontSize: "10px",
                },

              },
            },
          },
        },
      ],
    },

    series: [
      {
        name: "Şirkət sayı",
        data: typeOfCompanySeries
      }
    ]
  };




  // const customRowTooltip = ({ children, record, ...props }) => {
  //   console.log(record);
  //   return (
  //     <Tooltip title={`${record?.companyNames}`} placement="top">
  //       <tr {...props}>{children}</tr>
  //     </Tooltip>
  //   );
  // };
  return (
    <div className="dashboard" style={{ padding: "0px 16px" }}>
      {spin ? (
        <div className="flex flex-align-center justify-center mt-15">
          <Spin />
        </div>
      ) : (
        <>
          <Col>

            <Row gutter={[16, 16]}  >
              <Col xs={24} sm={12} lg={6}>
                <Card bordered={false} style={{ borderRadius: 16, textAlign: "center" }}>
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      margin: "0 auto 15px",
                      borderRadius: "50%",
                      background: "#eff6ff",
                      color: "#1677ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <BankOutlined style={{ fontSize: 20 }} />
                  </div>

                  <div
                    style={{
                      fontSize: 12,
                      color: "#94a3b8",
                      fontWeight: 700,
                      textTransform: "uppercase",
                    }}
                  >
                    Şirkətlər
                  </div>

                  <div style={{ fontSize: 23, fontWeight: 900, marginBottom: 10 }}>
                    <CountUp
                      end={data?.generalIndicators?.countOfCompanies ?? 0}
                      separator=" "
                    />
                  </div>
                </Card>
              </Col>

              <Col xs={24} sm={12} lg={6}>
                <Card bordered={false} style={{ borderRadius: 16, textAlign: "center" }}>
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      margin: "0 auto 15px",
                      borderRadius: "50%",
                      background: "#fff1f2",
                      color: "#ef4444",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CloseCircleOutlined style={{ fontSize: 20 }} />
                  </div>

                  <div
                    style={{
                      fontSize: 12,
                      color: "#94a3b8",
                      fontWeight: 700,
                      textTransform: "uppercase",
                    }}
                  >
                    Bağlanmış şirkətlər
                  </div>

                  <div style={{ fontSize: 23, fontWeight: 900, marginBottom: 10 }}>
                    <CountUp
                      end={data?.generalIndicators?.countOfDeactiveCompanies ?? 0}
                      separator=" "
                    />
                  </div>
                </Card>
              </Col>

              <Col xs={24} sm={12} lg={6}>
                <Card bordered={false} style={{ borderRadius: 16, textAlign: "center" }}>
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      margin: "0 auto 15px",
                      borderRadius: "50%",
                      background: "#ecfdf5",
                      color: "#10b981",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <DollarOutlined style={{ fontSize: 20 }} />
                  </div>

                  <div
                    style={{
                      fontSize: 12,
                      color: "#94a3b8",
                      fontWeight: 700,
                      textTransform: "uppercase",
                    }}
                  >
                    Nizamnamə kapitalı
                  </div>

                  <div style={{ fontSize: 23, fontWeight: 900, marginBottom: 10 }}>
                    <CountUp
                      end={data?.generalIndicators?.sumOfAuthorizedCapitalActiveCompanies ?? 0}
                      separator=" "
                    />
                  </div>
                </Card>
              </Col>

              <Col xs={24} sm={12} lg={6}>
                <Card bordered={false} style={{ borderRadius: 16, textAlign: "center" }}>
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      margin: "0 auto 15px",
                      borderRadius: "50%",
                      background: "#fffbeb",
                      color: "#f59e0b",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <TeamOutlined style={{ fontSize: 20 }} />
                  </div>

                  <div
                    style={{
                      fontSize: 12,
                      color: "#94a3b8",
                      fontWeight: 700,
                      textTransform: "uppercase",
                    }}
                  >
                    Əməkdaşlar
                  </div>

                  <div style={{ fontSize: 23, fontWeight: 900, marginBottom: 10 }}>
                    <CountUp
                      end={data?.generalIndicators?.sumOfEmployeeActiveCompanies ?? 0}
                      separator=" "
                    />
                  </div>
                </Card>
              </Col>
            </Row>
            <Row className="flex flex-between" gutter={16} style={{ alignItems: 'center' }}>
              <Col xs={24} lg={12} style={{marginBottom: "10px"}}>
                <Card
                  bordered={false}
                  style={{
                    borderRadius: 24,
                    padding: "0px 16px 16px",
                    // height: "100%",
                    height: "350px"
                  }}
                >
                  <h3
                    style={{
                      borderLeft: "4px solid #1677ff",
                      paddingLeft: 12,
                      fontWeight: 700,
                      fontSize: 16,
                      marginBottom: 24,
                    }}
                  >
                    Fəaliyyət sahəsinə görə
                  </h3>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Chart
                      options={activityField.options}
                      series={activityField.series}
                      type="donut"
                      width={responsive ? 500 : 420}
                      height={responsive ? 500 : 420}
                    />
                  </div>
                </Card>
              </Col>


              <Col xs={24} lg={12} style={{marginBottom: "10px"}}>
                <Card
                  bordered={false}
                  style={{
                    borderRadius: 24,
                    padding: "0px 16px 16px",
                    height: 350,
                  }}
                >
                  <h3
                    style={{
                      borderLeft: "4px solid #1677ff",
                      paddingLeft: 12,
                      fontWeight: 700,
                      fontSize: 16,
                      marginBottom: 24,
                    }}
                  >
                    {t("businessEntity")}
                  </h3>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      
                    }}
                  >
                    <Chart
                      options={typeOfCompany.options}
                      series={typeOfCompany.series}
                      type="donut"
                      width={responsive ? 500 : 420}
                      height={responsive ? 500 : 420}
                    />
                  </div>
                </Card>
              </Col>

            </Row>
          </Col>

          <Row gutter={16} className="mt-20">
            <Col className=" chart-div" xs={24} lg={12} style={{marginBottom: "10px"}}>

              <Card
                bordered={false}
                style={{
                  borderRadius: 20,
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 20,
                    alignItems: "center",
                  }}
                >
                  <h3
                    style={{
                      height: 34,
                      fontWeight: 600,
                      fontSize: 14,
                      color: "#94A3B8",
                      border: "none",
                    }}
                  >
                    İllərə görə Şirkətlər
                  </h3>

                  <div
                    style={{
                      background: "#f1f5f9",
                      padding: 4,
                      borderRadius: 12,
                      display: "inline-flex",
                      flexDirection: responsive2 ? "column" : "row",
                      gap: 4,
                    }}
                  >
                    <Button
                      type="text"
                      onClick={() => setComponyGrafikType(true)}
                      style={{
                        height: 34,
                        borderRadius: 8,
                        fontWeight: 600,
                        fontSize: 12,
                        background: componyGrafikType ? "#1677ff" : "transparent",
                        color: componyGrafikType ? "#fff" : "#64748b",
                        border: "none",
                        boxShadow: componyGrafikType
                          ? "0 2px 8px rgba(22,119,255,.25)"
                          : "none",
                      }}
                    >
                      Şirkətlərin sayı
                    </Button>

                    <Button
                      type="text"
                      onClick={() => setComponyGrafikType(false)}
                      style={{
                        height: 34,
                        borderRadius: 8,
                        fontWeight: 600,
                        fontSize: 12,
                        background: !componyGrafikType ? "#1677ff" : "transparent",
                        color: !componyGrafikType ? "#fff" : "#64748b",
                        border: "none",
                        boxShadow: !componyGrafikType
                          ? "0 2px 8px rgba(22,119,255,.25)"
                          : "none",
                      }}
                    >
                      Şirkətlərin Dinamikası
                    </Button>
                  </div>
                </div>

                <Chart
                  options={state1.options}
                  key={componyGrafikType}
                  series={state1.series}
                  type={componyGrafikType ? "bar" : "line"}
                  height={500}
                />
              </Card>
            </Col>
            <Col className="chart-div" xs={24} lg={12} style={{marginBottom: "10px"}}>
              <Card
                bordered={false}
                style={{
                  borderRadius: 20,
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 20,
                  }}
                >
                  <h3 style={{
                    height: 34,
                    fontWeight: 600,
                    fontSize: 14,
                    color: "#94A3B8",
                    border: "none",
                  }}>
                    Nizamnamə kapitalı böyüməsi
                  </h3>

                  <div
                    style={{
                      background: "#f1f5f9",
                      padding: 4,
                      borderRadius: 12,
                      display: "inline-flex",
                      flexDirection: responsive2 ? "column" : "row",
                      gap: 4,
                    }}
                  >
                    <Button
                      type="text"
                      onClick={() => setCapitalGrafikType(true)}
                      style={{
                        height: 34,
                        borderRadius: 8,
                        fontWeight: 600,
                        fontSize: 12,
                        border: "none",
                        background: capitalGrafikType ? "#1677ff" : "transparent",
                        color: capitalGrafikType ? "#fff" : "#64748b",
                        boxShadow: capitalGrafikType
                          ? "0 2px 8px rgba(22,119,255,.25)"
                          : "none",
                      }}
                    >
                      Nizamnamə kapitalı
                    </Button>

                    <Button
                      type="text"
                      onClick={() => setCapitalGrafikType(false)}
                      style={{
                        height: 34,
                        borderRadius: 8,
                        fontWeight: 600,
                        fontSize: 12,
                        border: "none",
                        background: !capitalGrafikType ? "#1677ff" : "transparent",
                        color: !capitalGrafikType ? "#fff" : "#64748b",
                        boxShadow: !capitalGrafikType
                          ? "0 2px 8px rgba(22,119,255,.25)"
                          : "none",
                      }}
                    >
                      Nizamnamə kapitalının dinamikası
                    </Button>
                  </div>
                </div>

                <Chart
                  options={state.options}
                  key={capitalGrafikType}
                  series={state.series}
                  type={capitalGrafikType ? "bar" : "line"}
                  height={500}
                />
              </Card>
            </Col>
          </Row>

          <Row gutter={16} className="mt-20">
            <Col xs={24}>
              <Card
                bordered={false}
                style={{
                  borderRadius: 24,
                  padding: 0,
                  overflow: "hidden",
                  padding: "10px 20px"
                }}
                bodyStyle={{ padding: 0 }}
              >
                {/* HEADER */}
                <div
                  style={{
                    padding: "20px 0px",
                    borderBottom: "1px solid #f1f5f9",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 16,
                  }}
                >
                  <div>
                    <h4
                      style={{
                        margin: 0,
                        height: 34,
                        fontWeight: 900,
                        fontSize: 16,
                        color: "black",
                        border: "none",
                      }}
                    >
                      Ən Çox Subyekt Təsis edən Rəsmi Şəxslər
                    </h4>

                    <p
                      style={{
                        margin: 0,
                        marginTop: 4,
                        fontSize: 11,
                        color: "#94a3b8",
                        fontWeight: 500,
                      }}
                    >
                      Sistem qeydiyyatları üzrə rəhbər və ya təsisçi kimi çıxış edən şəxslərin reytinqi
                    </p>
                  </div>

                  <div style={{ position: "relative", width: 240 }}>
                    <SearchOutlined
                      style={{
                        position: "absolute",
                        left: 10,
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#94a3b8",
                        fontSize: 16,
                      }}
                    />

                    <input
                      placeholder="Adlar üzrə axtarış..."
                      style={{
                        width: "100%",
                        padding: "6px 10px 6px 32px",
                        fontSize: 12,
                        fontWeight: 600,
                        background: "#f8fafc",
                        border: "1px solid #e2e8f0",
                        borderRadius: 10,
                        outline: "none",
                      }}
                    />
                  </div>
                </div>

                {/* TABLE */}
                <Table
                  size="small"
                  className="custom-table"
                  columns={columns}
                  dataSource={dashboardData}
                />


              </Card>
            </Col>
          </Row>

          <Row gutter={16} className="mt-20">
            <Col xs={24} lg={24}>
              <Card
                bordered={false}
                style={{
                  borderRadius: 24,
                  padding: 0,
                  overflow: "hidden",
                  width: "100%",
                }}
                bodyStyle={{ padding: 0 }}
              >
                {/* HEADER */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "20px 24px",
                    borderBottom: "1px solid #f1f5f9",
                    gap: 16,
                  }}
                >
                  {/* TITLE */}
                  <div>
                    <h4
                         style={{
                        margin: 0,
                        height: 34,
                        fontWeight: 900,
                        fontSize: 16,
                        color: "black",
                        border: "none",
                      }}
                    >
                      {bottomTab === "sayi"
                        ? "Fəaliyyət növünə görə şirkətlərin sayı"
                        : "Fəaliyyət növünə görə nizamnamə kapitalı"}
                    </h4>

                    <p
                      style={{
                        margin: 0,
                        marginTop: 4,
                        fontSize: 11,
                        color: "#94a3b8",
                        fontWeight: 500,
                      }}
                    >
                      30 əsas fəaliyyət üzrə dinamik analiz
                    </p>
                  </div>

                  {/* TOGGLE BUTTONS */}
                  <div
                    style={{
                      background: "#f1f5f9",
                      padding: 4,
                      borderRadius: 12,
                      display: "flex",
                      gap: 4,
                    }}
                  >
                    <Button
                      type="text"
                      onClick={() => setBottomTab("sayi")}
                      style={{
                        height: 32,
                        borderRadius: 8,
                        fontSize: 11,
                        fontWeight: 700,
                        border: "none",
                        background:
                          bottomTab === "sayi" ? "#1677ff" : "transparent",
                        color: bottomTab === "sayi" ? "#fff" : "#64748b",
                        boxShadow:
                          bottomTab === "sayi"
                            ? "0 2px 8px rgba(22,119,255,.25)"
                            : "none",
                      }}
                    >
                      Şirkətlərin sayı
                    </Button>

                    <Button
                      type="text"
                      onClick={() => setBottomTab("kapital")}
                      style={{
                        height: 32,
                        borderRadius: 8,
                        fontSize: 11,
                        fontWeight: 700,
                        border: "none",
                        background:
                          bottomTab === "kapital" ? "#1677ff" : "transparent",
                        color: bottomTab === "kapital" ? "#fff" : "#64748b",
                        boxShadow:
                          bottomTab === "kapital"
                            ? "0 2px 8px rgba(22,119,255,.25)"
                            : "none",
                      }}
                    >
                      Nizamnamə kapitalı
                    </Button>
                  </div>
                </div>

                {/* CHART AREA */}
                <div style={{ padding: "20px 24px" }}>
                  <Chart
                    options={
                      bottomTab === "sayi" ? state3.options : state2.options
                    }
                    series={
                      bottomTab === "sayi" ? state3.series : state2.series
                    }
                    type="bar"
                    height={550}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

export default Index;


